var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCohortFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.5a6.29 6.29 0 0 0 4 2.06v1.94a.75.75 0 0 1-.32.61l-2.5 1.75A.75.75 0 0 1 6 15.25V9.49zM10.7 0a5.3 5.3 0 1 1 0 10.6 5.3 5.3 0 0 1 0-10.6zM9.6 6.93 8.34 8.2a3.56 3.56 0 0 0 1.9.79V7.18a1.78 1.78 0 0 1-.63-.25zm4.55-1.13h-1.82a1.8 1.8 0 0 1-1.39 1.38V9a3.6 3.6 0 0 0 3.2-3.2zm-3.93-3.96A3.6 3.6 0 0 0 7 5.42c0 .87.3 1.67.82 2.29l1.27-1.29a1.8 1.8 0 0 1-.3-1c0-.87.61-1.6 1.43-1.76V1.84zM7.3 0A6.3 6.3 0 0 0 4.4 5.3v.16L.22 1.28A.75.75 0 0 1 .75 0h6.54zm3.65 1v2.66a1.8 1.8 0 0 1 1.4 1.42H15A4.53 4.53 0 0 0 10.94 1zm3.17-1h1.14a.75.75 0 0 1 .53 1.28l-.13.13A6.33 6.33 0 0 0 14.11 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohortFilter);
export default __webpack_public_path__ + "static/media/cohort-filter.097a6f23a884eb38fb2eb1ea5cb97ba5.svg";
export { ForwardRef as ReactComponent };